export const clampNumber = (value: number, min: number, max: number, fallback: number): number => {
  if (!Number.isFinite(value)) return fallback;
  return Math.min(max, Math.max(min, value));
};

export const parseSafeNumber = (
  raw: string | null | undefined,
  options: { min: number; max: number; fallback: number }
): number => {
  const value = Number(raw);
  return clampNumber(value, options.min, options.max, options.fallback);
};

export const limitTextLength = (value: string, maxLength: number): string => {
  if (value.length <= maxLength) return value;
  return value.slice(0, maxLength);
};
